<template>
  <div id="speakers">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <!-- <li class="nav-item">
            <el-dropdown stlye="height: 32px;" @command="handleCommand">
              <el-button size="small" type="warning" round><i style="font-size: 12px;" class="fas fa-exchange-alt"></i> {{ this.$t('event.components.participants.navbar.transfer.title') }}</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="import"><i class="fas fa-upload"></i> {{ this.$t('event.components.participants.navbar.transfer.import') }}</el-dropdown-item>
                <el-dropdown-item command="export"><i class="fas fa-download"></i> {{ this.$t('event.components.participants.navbar.transfer.export') }}</el-dropdown-item>
                <el-dropdown-item command="draft"><i class="fas fa-file-excel"></i> {{ this.$t('event.components.participants.navbar.transfer.exTask') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li> -->
          <li class="nav-item">
            <el-tooltip class="item" effect="dark" :content="$t('contentManagement.speakers.searchFilter')" placement="top">
              <el-button icon="fas fa-search" :type="$store.state.speakers.filter.searchTerm != '' && $store.state.speakers.filter.searchTerm != null ? 'success' : ''" size="small" circle @click="isFilterEnabled = !isFilterEnabled"></el-button>
            </el-tooltip>
          </li>
          <li class="nav-item">
            <el-button
              icon="fas fa-plus"
              type="primary"
              size="small"
              round
              @click="
                updateForm = null;
                modalVisible = true;
              "
            >
              {{ $t("contentManagement.speakers.addSpeaker") }}
            </el-button>
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="card card-collapsed filter-card">
            <div class="card-header">
              <div class="card-title-container">
                <h5 class="card-title">{{ $t("contentManagement.speakers.filter") }}</h5>
                <span>{{ $t("contentManagement.speakers.filterMsg") }}</span>
              </div>
              <div class="header-elements">
                <el-button-group>
                  <el-button @click="$store.state.speakers.filter.searchTerm = ''" icon="el-icon-refresh-right" size="mini" round>{{ $t("event.buttons.reset") }}</el-button>
                  <el-button type="warning" icon="el-icon-close" size="mini" @click="isFilterEnabled = false" round></el-button>
                </el-button-group>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-12">
                  <el-input clearable v-model="$store.state.speakers.filter.searchTerm" :placeholder="$t('event.textbox.speakerFilter')"></el-input>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ this.$t("event.menu.speakers.title") }}</h5>
              <span v-if="$store.state.speakers.items.length > 0" v-html="$t('totalContent', [$store.state.speakers.items.length])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe('https://holacon.com/product-guide/detail/how-to-add-speaker-on-event-planner-console')" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refreshList" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body" v-if="$store.state.speakers.items.length > 0">
            <div class="custom-grid-table-header speakers-grid-template">
              <span><i v-show="loading == 'loadingList'" class="el-icon-loading"></i></span>
              <div>{{ $t("contentManagement.speakers.speaker") }}</div>
              <div>{{ $t("contentManagement.speakers.viewing") }}</div>
              <div></div>
            </div>
            <draggable :list="$store.state.speakers.items" tag="div" handle=".el-icon-s-grid" class="list-group-o event-speakers-container" v-bind="dragOptions" @start="dragList = true" @end="changeSpeakersSorting">
              <div class="item" v-for="item in $store.state.speakers.items" :key="item.id" :class="{ passive: !item.isActive }">
                <div class="table-icon">
                  <i class="burger" :class="loading == item.id ? 'el-icon-loading' : 'el-icon-s-grid'"></i>
                </div>
                <div class="img-title"> 
                  <span class="item-color-container">{{ item.orderNO }}</span>
                  <div class="img" :style="'background-image:url(' + $imageus + item.image + '?width=100&height=100&mode=cover)'"></div>
                  <div class="img-title-alt">
                    <div class="speaker-title">
                      {{ item.fullName }}
                    </div>
                    <span>
                      {{ item.title }}
                      <b v-if="(item.firmName != null) & (item.firmName != '')">@ {{ item.firmName }}</b>
                    </span>
                  </div>
                </div>
                <div><el-switch v-model="item.isActive" :disabled="loading == item.id" @change="statusChanged(item.id)"></el-switch></div>
                <div class="action-btns">
                  <el-tooltip effect="dark" :content="$t('event.table.edit')" placement="top">
                    <el-button
                      type="primary"
                      icon="fas fa-pen"
                      circle
                      size="mini"
                      @click="
                        updateForm = item.id;
                        modalVisible = true;
                      "
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="$t('event.table.delete')" placement="top">
                    <el-popconfirm @confirm="deleteItem(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                      <el-button slot="reference" type="danger" icon="fas fa-trash" :loading="loading == 'deleteItem-' + item.id" circle size="mini"></el-button>
                    </el-popconfirm>
                  </el-tooltip>
                </div>
              </div>
            </draggable>
          </div>
          <div v-else>
            <HolaconLottieNoData
              class="w-100"
              key="create-loading"
              :source="'holacon-speakers-lottie'"
              :title="$t('event.menu.speakers.title')"
              @btnAdd="
                updateForm = null;
                modalVisible = true;
              "
              @btnRefresh="refreshList()"
              :buttonAdd="true"
              :buttonRefresh="true"
              :loading="loading"
            />
          </div>

          <div class="card-footer"></div>
        </div>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="updateForm ? $t('contentManagement.speakers.editSpeaker') : $t('contentManagement.speakers.addSpeaker')" class="large" center modal-append-to-body destroy-on-close>
      <SpeakerAddUpdate @deleteMe="deleteItem" @closeDialog="modalVisible = false" v-if="modalVisible" :id="updateForm" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="excelDialog" :title="'İçeri aktar'" class="medium" center modal-append-to-body destroy-on-close>
      <ExcelImport :key="excelDialog" @closeDialog="excelDialog = false" endpoint="speaker/import" />
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import SpeakerAddUpdate from "../../components/SpeakerAddUpdate";
import ExcelImport from "../../components/ExcelImport";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import $ from "jquery";
export default {
  components: { SpeakerAddUpdate, ExcelImport, PageCountInfo, draggable },
  name: "Speakers",
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.speakers")
    };
  },
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      loading: false,
      drag: false,
      speakerSort: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "speaker",
      widgetUrl: null,
      excelTemplateUrl: null
    };
  },
  methods: {
    exportExcel() {
      this.$confirm(this.$t("message.export"), this.$t("message.warn"), {
        confirmButtonText: this.$t("event.variables.yes"),
        cancelButtonText: this.$t("event.variables.no"),
        type: "warning"
      }).then(() => {
        axios.post("speaker/export", { id: null }).then(res => {
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
          }
        });
      });
    },
    excelProgress(event) {
      this.excelPercent = event.percent;
    },
    handleCommand(command) {
      if (command == "import") {
        this.excelDialog = true;
        return;
      } else if (command == "export") {
        this.exportXlsx(8, null, JSON.stringify(this.$store.state.speakers.filter));
        return;
      } else if (command == "draft") {
        window.open(this.excelTemplateUrl, "_blank");
        return;
      } else {
        return;
      }
    },
    async refreshList() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "loadingList";
      await this.$store.dispatch("getSpeakers");
      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },

    deleteItem(id) {
      this.loading = "deleteItem-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deleteSpeakerPage", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getSpeakers");
        }
        this.loading = false;
      }, 500);
    },
    async statusChanged(id) {
      this.loading = id;
      if (this.speakerSort != null) clearTimeout(this.speakerSort);
      this.speakerSort = setTimeout(async () => {
        await this.$store.dispatch("toggleActiveSpeaker", id);
        this.loading = false;
      }, 500);
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedSpeakers", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
    changeSpeakersSorting() {
      if (this.speakerSort != null) clearTimeout(this.speakerSort);
      this.loading = "loadingList";
      this.speakerSort = setTimeout(async () => {
        var payload = [];
        this.$store.state.speakers.items.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("saveSpeakerSort", payload);
        await this.$store.dispatch("getSpeakers");
        this.loading = false;
      }, 500);
    }
  },
  mounted() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      this.$store.dispatch("getSpeakers");
      this.loading = false;
    }, 500);
  },
  created() {
    this.widgetUrl = "https://cdn.holacon.com/widgets/event-speakers.html?eventID=" + this.currentEvent.id + "&applicationID=" + this.currentEvent.applicationID;
    this.excelTemplateUrl = this.$excelTemplateUrl + "sample/SpeakerExcel/SpeakerImportSample.xlsx";
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    currentEvent() {
      return this.$store.getters.currentEvent;
    },
    skip() {
      return (this.$store.state.speakers.filter.page - 1) * this.$store.state.speakers.filter.take;
    },
    take() {
      return this.skip + this.$store.state.speakers.items.length;
    }
  },
  watch: {
    "$store.state.speakers.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getSpeakers");
      }, 500);
    }
  }
};
</script>

<style lang="less" scoped>
.speakers-grid-template {
  grid-template-columns: 36px 1fr 90px 90px;
}

.item-color-container {
  padding: 5px 10px;
  width: max-content;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.8);
  font-weight: 600;
  color: #505763;
  font-size: 13px;
}
.event-speakers-container {
  display: flex;
  flex-direction: column;
  .item {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: unset;
    }

    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: column;
        .speaker-title {
          font-size: 14px;
          color: #292f3b;
          font-weight: 600;
          line-height: normal;
        }
        span {
          font-size: 13px;
          display: block;
          font-weight: 500;
          color: #505763;
          line-height: normal;
        }
      }
      & > .img {
        border-radius: 50%;
        width: 45px;
        min-width: 45px;
        height: 45px;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        overflow: hidden;
        border: 3px solid white;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f1f1f1;
    &.passive {
      background-color: #fff2f2 !important;
    }
    display: grid;
    grid-template-columns: 36px 1fr 90px 90px;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
      &.me {
        color: #ccc;
      }
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.model-base-small {
  min-width: 1140px;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/Speakers.vue